import { render, staticRenderFns } from "./UserTrustPointsItem.vue?vue&type=template&id=37b6c410&scoped=true&"
import script from "./UserTrustPointsItem.vue?vue&type=script&lang=js&"
export * from "./UserTrustPointsItem.vue?vue&type=script&lang=js&"
import style0 from "./UserTrustPointsItem.vue?vue&type=style&index=0&id=37b6c410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6c410",
  null
  
)

export default component.exports